import axios from 'axios'
import MtaH5 from 'mta-h5-analysis'

let performanceLogT = 0

let sendPerformanceLog = function () {
  let data = {
    pTime: window.performance.timing.toJSON(),
    sign: 'qdActStat' + (parseInt((new Date()).getTime() / 1000) / 4).toFixed(2),
    url: encodeURIComponent(window.location.href).toLowerCase(),
    platform: 1
  }
  axios.post(
    global.API_HOST + 'SyAct/Statistic/addPerformanceLog', data
  ).then(function (response) {
    if (response.data.code !== 0) {
      console.log('add pTime failed')
    }
  })
}
export default {
  addRecord (action, origin = '', url = null) {
    if (url === null) {
      url = window.location.href
    }
    let requestUrl = global.API_HOST +
      'qqread/ad/track?platformId=' + global.PLATFORMID +
      '&action=' + action +
      '&origin=' + origin +
      '&url=' + encodeURIComponent(url)
    axios.get(requestUrl)
      .then(function (response) {
        if (response.data.code !== 0) {
          console.log('add record failed')
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  addMtaEvent (action) {
    MtaH5.clickStat(action, {'page': document.title})
  },
  addPerformanceLog () {
    performanceLogT = setInterval(function () {
      if (document.readyState === 'complete') {
        sendPerformanceLog()
        clearInterval(performanceLogT)
      }
    }, 10)
  }
}



// WEBPACK FOOTER //
// ./src/v2/static/js/statistic.js